import React, { useEffect, useState, useRef } from 'react';
import ReactPlayer from 'react-player';
import { Table, Space, Drawer, Form, Input, Button, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import {
    list_video_guide_ActionHandler,
    delete_video_guide_ActionHandler,
    list_edit_video_guide_ActionHandler,
    edit_video_guide_ActionHandler,
} from '../../../../Redux/Actions/user/createVideoGuide';
import './ResourceStyle.css';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../../Components/Loader/Loader';

const EditDrawer = ({
    visible,
    onClose,
    record,
    setDrawerVisible,
    selectedRecord,
}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        //gtm
        window.dataLayer.push({
            event: 'Edit Guillines ',
            buttonName: 'Edit Guillines ',
            userId: JSON.parse(localStorage.getItem('userDetails'))?.id,
            clientId: JSON.parse(localStorage.getItem('userDetails'))
                ?.client_id,
        });
    }, []);

    const [form] = Form.useForm();
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);
    const [video, setVideo] = useState(null);
    const [fieldValue, setFieldValue] = useState({});
    useEffect(() => {
        if (record) {
            setFieldValue({
                name: record.name,
                url: record.presigned_url,
            });
            form.setFieldsValue({
                name: record.name,
                url: record.presigned_url,
            });
        }
    }, [form, record]);

    const onFinish = (values) => {
        onClose();
    };
    const handleButtonClick = () => {
        fileInputRef.current.click();
    };
    const handleFileChange = () => {
        const file = fileInputRef.current.files[0];
        setSelectedFile(file);
    };
    const handleSaveChanges = (e) => {
        debugger;
        e.preventDefault();
        if (fieldValue) {
            const formData = new FormData();
            formData.append('video', selectedFile);
            formData.append('name', fieldValue.name);
            dispatch(edit_video_guide_ActionHandler(record.id, formData));
            setDrawerVisible(false);
        }
    };

    return (
        <Drawer placement='right' closable={true} visible={visible} width={500}>
            <div className='new-btn'>
                <h2>Edit Video Guides</h2>
                <Button
                    className='close-btn'
                    type='text'
                    placement='right'
                    shape='circle'
                    icon={<CloseOutlined />}
                    size='large'
                    onClick={onClose}
                />
            </div>
            <div className='main-div'>
                <div>
                    <Form>
                        <div className='video-input-field'>
                            <label>Video Title</label>
                            <Input
                                placeholder='Sample'
                                value={fieldValue.name}
                                onChange={(e) =>
                                    setFieldValue({
                                        ...fieldValue,
                                        name: e.target.value,
                                    })
                                }
                            />
                        </div>

                        <div className='video-input-field2'>
                            <div className='video-div'>
                                <div className='video-guide'>
                                    <label className='video-lable'>
                                        Video Guide
                                    </label>
                                    <ReactPlayer
                                        url={fieldValue.url}
                                        width='80%'
                                        height='100px'
                                        controls
                                    />
                                </div>

                                <div>
                                    <input
                                        type='file'
                                        accept='.mp4, .mov, .avi, .mkv, .webm'
                                        ref={fileInputRef}
                                        id='fileInput'
                                        style={{ display: 'none' }}
                                        onChange={handleFileChange}
                                    />
                                    {selectedFile && (
                                        <p style={{ margin: '3px' }}>
                                            {selectedFile.name}
                                        </p>
                                    )}

                                    <label htmlFor='fileInput'>
                                        <button
                                            type='button'
                                            className='repl-btn'
                                            onClick={handleButtonClick}>
                                            <svg
                                                className='svg-up'
                                                xmlns='http://www.w3.org/2000/svg'
                                                width='16'
                                                height='16'
                                                viewBox='0 0 16 16'
                                                fill='none'>
                                                <path
                                                    d='M7.7553 5.90625H1.57739C1.44379 5.90625 1.33301 5.67958 1.33301 5.40625C1.33301 5.13292 1.44053 4.90625 1.57739 4.90625H7.7553C7.88889 4.90625 7.99967 5.13292 7.99967 5.40625C7.99967 5.67958 7.89215 5.90625 7.7553 5.90625Z'
                                                    fill='#292D32'
                                                />
                                                <path
                                                    d='M5.83301 5.81422C5.55967 5.81422 5.33301 5.58755 5.33301 5.31422V2.07422C5.33301 1.80089 5.55967 1.57422 5.83301 1.57422C6.10634 1.57422 6.33301 1.80089 6.33301 2.07422V5.31422C6.33301 5.58755 6.10634 5.81422 5.83301 5.81422Z'
                                                    fill='#292D32'
                                                />
                                                <path
                                                    d='M7.39333 12.7449C7.15333 12.7449 6.92667 12.6849 6.72 12.5715C6.26667 12.3049 6 11.7715 6 11.0982V9.49821C6 8.82488 6.26667 8.28488 6.72667 8.01821C7.18667 7.75155 7.78667 7.79155 8.36667 8.13155L9.75333 8.93155C10.3333 9.26488 10.6733 9.76488 10.6733 10.2982C10.6733 10.8315 10.3333 11.3315 9.74667 11.6649L8.36 12.4649C8.04 12.6515 7.70667 12.7449 7.39333 12.7449ZM7.4 8.84488C7.33333 8.84488 7.27333 8.85821 7.22667 8.88488C7.08667 8.96488 7 9.19155 7 9.49821V11.0982C7 11.3982 7.08667 11.6249 7.22667 11.7115C7.36667 11.7915 7.60667 11.7515 7.86667 11.5982L9.25333 10.7982C9.51333 10.6449 9.67333 10.4582 9.67333 10.2982C9.67333 10.1382 9.52 9.95155 9.25333 9.79821L7.86667 8.99821C7.69333 8.89821 7.52667 8.84488 7.4 8.84488Z'
                                                    fill='#292D32'
                                                />
                                                <path
                                                    d='M9.99967 15.1654H5.99967C2.37967 15.1654 0.833008 13.6187 0.833008 9.9987V5.9987C0.833008 2.3787 2.37967 0.832031 5.99967 0.832031H8.66634C8.93967 0.832031 9.16634 1.0587 9.16634 1.33203C9.16634 1.60536 8.93967 1.83203 8.66634 1.83203H5.99967C2.92634 1.83203 1.83301 2.92536 1.83301 5.9987V9.9987C1.83301 13.072 2.92634 14.1654 5.99967 14.1654H9.99967C13.073 14.1654 14.1663 13.072 14.1663 9.9987V6.66536C14.1663 6.39203 14.393 6.16536 14.6663 6.16536C14.9397 6.16536 15.1663 6.39203 15.1663 6.66536V9.9987C15.1663 13.6187 13.6197 15.1654 9.99967 15.1654Z'
                                                    fill='#292D32'
                                                />
                                                <path
                                                    d='M10.4466 6.49833C10.1866 6.49833 9.94659 6.405 9.77326 6.225C9.56659 6.01833 9.46659 5.71167 9.51326 5.39833L9.64659 4.47166C9.67992 4.23833 9.81992 3.95166 9.99326 3.785L12.4133 1.365C13.3799 0.398332 14.2199 0.951665 14.6333 1.365C15.0266 1.75833 15.2066 2.17167 15.1666 2.59833C15.1333 2.93833 14.9599 3.265 14.6333 3.585L12.2133 6.005C12.0466 6.17166 11.7599 6.31166 11.5266 6.35166L10.5999 6.485C10.5466 6.49833 10.4933 6.49833 10.4466 6.49833ZM13.1133 2.07833L10.6933 4.49833C10.6733 4.51833 10.6399 4.59166 10.6333 4.625L10.5066 5.49166L11.3799 5.37167C11.4066 5.365 11.4799 5.33166 11.5066 5.305L13.9266 2.885C14.0733 2.73833 14.1599 2.605 14.1666 2.505C14.1799 2.365 14.0399 2.19166 13.9266 2.07833C13.5799 1.73166 13.4199 1.77166 13.1133 2.07833Z'
                                                    fill='#292D32'
                                                />
                                                <path
                                                    d='M13.9335 4.08586C13.8868 4.08586 13.8402 4.07919 13.8002 4.06586C12.9068 3.81252 12.1935 3.09919 11.9402 2.20586C11.8668 1.93919 12.0202 1.66586 12.2868 1.59252C12.5535 1.51919 12.8268 1.67252 12.9002 1.93919C13.0602 2.49919 13.5068 2.95252 14.0735 3.11252C14.3402 3.18586 14.4935 3.46586 14.4202 3.72586C14.3468 3.93919 14.1468 4.08586 13.9335 4.08586Z'
                                                    fill='#292D32'
                                                />
                                            </svg>
                                            Replace Video
                                        </button>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className='upload'>
                            <button
                                type='submit'
                                className='upload-button'
                                onClick={handleSaveChanges}>
                                Save Changes
                            </button>
                        </div>
                    </Form>
                </div>
            </div>
        </Drawer>
    );
};
const EditVideoGuides = () => {
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    let dispatch = useDispatch();
    const videoGuideData = useSelector(
        (state) =>
            state.list_edit_video_guide_data.list_edit_video_guide_data.data
    );
    useEffect(() => {
        dispatch(list_edit_video_guide_ActionHandler());
    }, [dispatch]);

    const handleEditClickNew = (record) => {
        setSelectedRecord(record);
        setDrawerVisible(true);
    };
    const handleDeleteClick = (record) => {
        setSelectedRecord(record);
        setDeleteModalVisible(true);
    };
    const handleDeleteConfirm = async () => {
        if (selectedRecord) {
            dispatch(delete_video_guide_ActionHandler(selectedRecord.id));
            setDeleteModalVisible(false);
        }
    };
    const handleDeleteCancel = () => {
        setDeleteModalVisible(false);
    };

    const handleDrawerClose = () => {
        setDrawerVisible(false);
    };

    const columns = [
        {
            title: 'Title',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Video Guide',
            dataIndex: 'presigned_url',
            key: 'presigned_url',
            render: (videoUrl) => (
                <Space>
                    <video width='120' height='60' controls>
                        <source src={videoUrl} type='video/mp4' />
                        Your browser does not support the video tag.
                    </video>
                </Space>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <Space size='middle'>
                    {/* Add your action buttons or links here */}
                    <a
                        href='#'
                        style={{ cursor: 'pointer !important ' }}
                        onClick={() => handleEditClickNew(record)}>
                        Edit
                    </a>
                    <a
                        href='#'
                        style={{ cursor: 'pointer !important' }}
                        onClick={() => handleDeleteClick(record)}>
                        Delete
                    </a>
                </Space>
            ),
        },
    ];

    return (
        <div className='main-cont-up'>
            {/* {<Loader />} */}
            <div>
                <Table
                    dataSource={videoGuideData}
                    columns={columns}
                    pagination={{ pageSize: 10 }}
                />
                <EditDrawer
                    visible={drawerVisible}
                    onClose={handleDrawerClose}
                    record={selectedRecord}
                    setDrawerVisible={setDrawerVisible}
                />

                <Modal
                    title='Confirm Delete'
                    visible={deleteModalVisible}
                    onOk={handleDeleteConfirm}
                    onCancel={handleDeleteCancel}
                    okText='Delete'
                    cancelText='Cancel'
                    okButtonProps={{
                        style: {
                            backgroundColor: 'red',
                            borderColor: '#ff4d4f',
                        },
                    }}>
                    <p>Are you sure you want to delete this item?</p>
                </Modal>
            </div>
        </div>
    );
};
export default EditVideoGuides;
